<template>
  <b-card v-if="crossDomainSearchList.length > 0" no-body class="multisearch-card">
    <b-tabs class="multisearch-tabs" no-fade cart small v-model="tabIndex">
      <b-tab
        v-for="(cds, index) in crossDomainSearchList"
        :key="index"
        :title="cds.tabTitle"
        class="multisearch-tab-content">
        <!-- <h4 class="multisearch-content-title">{{ cds.title }}</h4> -->
        <div class="multisearch-logo">
          <b-link :href="getHostName(cds.url)">
            <img @click="getHostName(cds.url)" :src="host + cds.logoUrl" alt="cds.title">
          </b-link>
        </div>
        <div class="input-group multisearch-content">
          <input
            v-model="keyWord"
            :placeholder="cds.placeholder"
            type="text"
            class="form-control multisearch-content-input"
            aria-label="search"
            aria-describedby="search">
          <div class="input-group-append">
            <button @click="crossOriginSearch(cds)" class="btn multisearch-content-btn" type="button">
              <span class="search-btn">
                <i class="fas fa-search"></i>
              </span>
            </button>
          </div>
        </div>
        <p class="multisearch-content-description">{{ cds.description }}</p>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      crossDomainSearchList: [],
      tabIndex: 0,
      keyWord: ""
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    }
  },

  created() {
    this.getMultiSearchList();
  },

  methods: {
    getHostName(url) {
      return url.substring(0, url.indexOf("search?"));
    },

    crossOriginSearch(cds) {
      if (this.keyWord.trim()) {
        let crossUrl = cds.url.replace(cds.keyWord, this.keyWord);
        window.open(crossUrl, "_blank");
      }
    },

    getMultiSearchList() {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getmultisearchlist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.crossDomainSearchList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  }
};
</script>

<style lang="scss">
.multisearch-card {
  border: 0;
  border-radius: 0;
  background-color: transparent;

  .multisearch-tabs {
    .multisearch-tab-content {
      background-color: #ffffff;
      padding: 3rem;
      border: 1px solid #ededed;
      border-top: 0;

      .multisearch-content-title {
        padding: 0.5rem;
        text-align: center;
        font-size: 1rem;
      }

      .multisearch-logo {
        text-align: center;
        margin: 1rem auto;

        img {
          height: 5rem;
        }
      }

      .multisearch-content {
        width: 60%;
        margin: 0 auto;

        .form-control {
          border: 1px solid #d3d2d2;
          border-right: 0;
          border-radius: 0;
          box-shadow: none;

          &:focus {
            border: 1px solid #008496;
            border-right: 0;
            border-radius: 0;
            outline: none;
          }
        }

        .input-group-append .multisearch-content-btn {
          padding: 0 0.125rem;
          background-color: #ffffff;
          color: #ffffff;
          border: 1px solid #d3d2d2;
          border-left: 0;
          border-radius: 0;

          &:focus {
            border-left: 0;
            box-shadow: none;
          }

          &:hover {
            background-color: #ffffff;
            color: #ededed;
          }

          .search-btn {
            display: inline-block;
            padding: 0.25rem 1rem;
            background-color: #008496;
          }
        }
      }

      .multisearch-content-description {
        margin-top: 1rem;
        text-align: center;
        color: #969696;
        height: 3rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
}

/* RTL */

.rtl-layout {

  .multisearch-card {

    .nav-tabs {
      direction: rtl !important;
      padding-right: 1px;

      .nav-item {

        .nav-link {
          padding-top: 7px;
          padding-bottom: 0;
        }
      }
    }

    .multisearch-content {
      direction: rtl;

      .multisearch-content-input {
        border-right: 1px solid #d3d2d2 !important;
        border-left: none !important;
        direction: rtl;
        text-align: right;
      }

      .input-group-append button {
        border-left: 1px solid #d3d2d2 !important;
        border-right: none !important;
        
        .search-btn {
          position: relative;
          height: 32px;
          width: 48px;
          vertical-align: middle;

          i {
            position: absolute;
            top: 8px;
            left: 17px;
          }
        }

        &:focus {
          border-right: none !important;
          border-left: 1px solid #008496 !important;
        }
      }
    }

    .form-control {
      &:focus {
        border: 1px solid #008496;
        border-left: 0;
        border-right: 1px solid #008496 !important;
        border-radius: 0;
        outline: none;
      }
    }
  }
}
</style>

<style>
.multisearch-content .multisearch-content-input::-webkit-input-placeholder {
  color: #c0c0c0;
}
.multisearch-content .multisearch-content-input::-moz-placeholder {
  color: #c0c0c0;
}
.multisearch-content .multisearch-content-input:-ms-input-placeholder {
  color: #c0c0c0;
}
.multisearch-content .multisearch-content-input:-moz-placeholder {
  color: #c0c0c0;
}
.multisearch-content .multisearch-content-input:focus {
  border: 1px solid #008496;
  border-right: 0;
}
.multisearch-content .form-control:focus + .input-group-append .multisearch-content-btn {
  border: 1px solid #008496 !important;
  border-left: 0;
}
.multisearch-card .nav-tabs,
.multisearch-card .nav-tabs:focus {
  padding-left: 1px;
  border-bottom: 0;
  outline: none;
}
.multisearch-card .nav-tabs .nav-item {
  margin-bottom: 0;
}
.multisearch-card .nav-link {
  border-top: 2px solid #00849611;
  padding: 4px 16px;
  font-size: 1.125rem;
  font-weight: 500;
}
.multisearch-card .nav-tabs .nav-link.active,
.multisearch-card .nav-tabs .nav-item.show .nav-link,
.multisearch-card .nav-tabs .nav-link.active:hover,
.multisearch-card .nav-tabs .nav-item.show .nav-link:hover {
  border-top: 2px solid #008496;
  background-color: #00849622;
  border-top-width: 100%;
  border-left: none;
  border-right: none;
  border-bottom: 0;
  background: #ffffff;
  color: #008496;
  font-size: 1.125rem;
}
.multisearch-card .nav-tabs .nav-link {
  border-top: 2px solid #00849600;
  border-top-width: 0;
  background-color: #00849600;
  border-bottom: 0;
  border-radius: 0;
  color: #777777;
  transition: all 0.3s ease-in-out;
}
.multisearch-card .nav-tabs .nav-link:hover {
  border-top: 2px solid #006b75;
  border-bottom: 0;
  border-radius: 0;
}
.multisearch-card .nav-tabs, .multisearch-card .nav-tabs:focus {
  background-color: #00849611;
}
</style>
